const _global = (typeof window !== 'undefined' ? window : typeof global !== 'undefined' ? global : typeof self !== 'undefined' ? self : {}); _global.SENTRY_RELEASE={id:"2eba63cc985d6a062186c355f08086adc0aef3cd"};
      _global.SENTRY_RELEASES=_global.SENTRY_RELEASES || {};
      _global.SENTRY_RELEASES["web-frontend@codingal-inc"]={id:"2eba63cc985d6a062186c355f08086adc0aef3cd"};
      